import type { AxiosInstance } from "axios";

import { Roles } from "api/schemas/shared";
import { getRolePathPrefix } from "api/services/utils";
import { validateResponse } from "api/validateResponse";

import { type GetPatientArgs, PatientSchema } from "./schemas/patient";
import { type GetTreatmentAdherenceArgs, TreatmentAdherenceSchema } from "./schemas/treatment_adherence";

interface CreatePatientServiceArgs {
  transportV1: AxiosInstance;
  transportV2: AxiosInstance;
}

export const createPatientService = ({ transportV1, transportV2 }: CreatePatientServiceArgs) => ({
  async getPatientProfile(args: GetPatientArgs) {
    const { patientID, treatment_id } = args;
    const params = { treatment_id };
    const response = await transportV1.get(`/patients/${patientID}`, { params });
    return validateResponse(response, PatientSchema, false);
  },

  async getTreatmentAdherence(args: GetTreatmentAdherenceArgs) {
    const { patient_id, role = Roles.Therapist, treatment_id, params } = args;
    const response = await transportV2.get(
      `${getRolePathPrefix(role)}/patients/${patient_id}/treatments/${treatment_id}/adherence`,
      {
        params,
      }
    );
    return validateResponse(response, TreatmentAdherenceSchema, false);
  },
});

export type PatientService = ReturnType<typeof createPatientService>;
